// extracted by mini-css-extract-plugin
module.exports = {"linkColor":"d_N","link":"l_5 d_N"};